/*
 * @Author: Huangxianlong
 * @Date: 2023-05-29 10:27:17
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2023-06-27 10:54:41
 * @FilePath: \h5\src\store\modules\app.js
 * @Description: 
 */
import * as api from '../../api';
import { router } from '../../router/index';

const app = {
  state: {
    menuTheme: 'dark', // 主题
    themeColor: '',
    currentPageName: '',
    currentPath: [
      {
        title: 'EOSBoot',
        path: '',
        name: 'home_index'
      }
    ],
    routers: [
    ],
  },
  mutations: {

  },
  getters: {

  },
  actions: {

  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js